import React from 'react'
import { browserHistory } from 'react-router'

export default class Insurance extends React.Component {
    constructor(props) {
        super(props);
    }

    componentWillUpdate(nextProps, nextState) {

    }

    render(){
        return (
            <div>
                <span class="go-back go-back-left-side" onClick={browserHistory.goBack}><i class="icon-arrow-left"></i></span>
                <div>Forms to Add Tenants here</div>
            </div>
        )
    }
};


// WEBPACK FOOTER //
// app/views/Insurance/Insurance.jsx